import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {GameInfo} from '../../../services/games/game-info';
import {GameImageContainerComponent} from '../common/parts/game-image-container.component/game-image-container.component';
import {GameBox} from './boxes/game/game.box';
import {GameImageContainerBox} from './boxes/game-image-container/game-image-container.box';
import {GameDetailsContainerComponent} from './parts/game-details-container/game-details-container.component';
import {GAME_BOX_JACKPOT_TEMPLATE} from '../css-constants';

export interface SingleGameJackpotTemplateComponentProps {
    gameInfo: GameInfo;
    className: string;
    onOpenRealGame: () => void;
}

@observer
export class SingleGameJackpotTemplateComponent extends OrbitComponent<SingleGameJackpotTemplateComponentProps> {


    render() {
        let gameInfo = this.props.gameInfo;

        return (
            <GameBox className={`cy-single-game-jackpot-template ${GAME_BOX_JACKPOT_TEMPLATE} ${this.props.className}`}>
                <GameImageContainerComponent gameInfo={gameInfo}
                                             box={GameImageContainerBox}
                                             onOpenRealGame={this.props.onOpenRealGame}
                                             playRealGameButton={null}/>

                <GameDetailsContainerComponent gameInfo={gameInfo} onOpenRealGame={this.props.onOpenRealGame}/>
            </GameBox>
        );
    }
}